import React, { useContext } from "react";
import styled                from "styled-components";
import { OrderContext }      from "~/contexts/OrderContext";

const OrderNotesContainer = styled.div`
  padding-top: 2rem;
  padding-bottom: 2rem;
  textarea {
    width: 100%;
    min-height: 200px;
    padding: 8px;
    font-size: 12px;
  }
  p {
    display: none;
  }

  @media print {
      display: none;
  }
`;

export const OrderNotes = () => {
  const { order, dispatch } = useContext(OrderContext);

  const onChange = ({ currentTarget: { value } }) => {
    dispatch({
      type: "NOTES_UPDATED",
      payload: value,
    });
  };

  return (
    <OrderNotesContainer>
      <div className="mb-4">Notes</div>
      <textarea onChange={onChange} value={order?.attributes?.notes} />
      <p
        dangerouslySetInnerHTML={{
          __html: order?.attributes?.notes?.replace(/\n/g, "<br>"),
        }}
      />
    </OrderNotesContainer>
  );
};
